import React, {useState} from 'react'
import './register.css'
import axios from "axios"
import { useHistory } from 'react-router-dom'
import { Notify} from "notiflix";
import Navbar from '../../components/navbar/Navbar';

function Register() {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const api_uri = "https://mentorxfa.herokuapp.com/api";

    const history = useHistory();

    const handleSubmit = async (e) =>{
        e.preventDefault();
        setError(false);
        try {
            const res = await axios.post(api_uri+"/auth/register", {
                username, email, password
            })
            Notify.success('Account Successfully Created');

            setTimeout(() => {   
                res.data && history.push("/login")
            }, 400)
        } catch (err) {
            setError(true);
        }
    }
    return (
        <>
        <Navbar/> 
        <div className="register">   
            <h2 className="register-title">Sign Up</h2>  
            <p className="register-desc">
                    Share your resources with other by Register with us.
            </p>               
            <form action="" className="register-form" onSubmit={handleSubmit}>
                <input type="text" className="register-form-input" required placeholder="Enter Username" onChange={e=>setUsername(e.target.value)} />
                <input type="email" className="register-form-input" required placeholder="Enter Email"  onChange={e=>setEmail(e.target.value)} />
                <input type="password" className="register-form-input" required placeholder="Enter Password" onChange={e=>setPassword(e.target.value)} />
                <button type="submit" className="register-form-btn">Register</button>
            </form>
            {error && <span style={{marginTop:"10px"}}>Something went wrong</span> }
        </div>
        </>
    )
}

export default Register
